import { useMemo } from 'react';
import { getAddonPrice } from '../addonPricing';

const getItemPrice = (item, isMember) => {
  if (!item) return 0;
  if (isMember) return item.price_rate?.member_after_6_or_weekends ?? 0;
  return item.price_rate?.nonMemberPrice ?? item.price ?? 0;
};

/**
 * Calculate total price of all services and addons with membership pricing
 * Used across multiple pages: AppointmentSummary, GuestsAndServices, ReviewAndConfirmBooking, ContactDetail, SelectServices
 *
 * @param {Array} members - Array of guest members with services and addons
 * @param {boolean} membership - Whether customer has membership status
 * @returns {number} Total cart price
 */
export const useCartDisplayTotal = (members = [], membership = false) => {
  const flatServices = useMemo(
    () => members.flatMap((member) => member.services || []),
    [members]
  );

  const cartDisplayTotal = useMemo(
    () =>
      flatServices.reduce((sum, service) => {
        const servicePrice = parseFloat(getItemPrice(service, membership)) || 0;
        const addonsPrice = (service?.selectedAddons || []).reduce(
          (addonSum, addon) => addonSum + getAddonPrice(addon),
          0
        );
        return sum + servicePrice + addonsPrice;
      }, 0),
    [flatServices, membership]
  );

  return cartDisplayTotal;
};
